import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import { getDownloadHouseholdDocumentsUrl } from 'common/householdHelpers';

const SrHouseholdDownloadDocuments = ({
  children,
  householdId,
  listingId,
  appUrl,
  noUnderline,
  className,
  regenerateDocs,
}) => {
  const onClickDownloadDocuments = (e) => {
    preventDefaultPropagation(e);

    const downloadDocumentsUrl = getDownloadHouseholdDocumentsUrl({
      appUrl,
      listingId,
      householdId,
      regenerateDocs: regenerateDocs || false,
    });

    global.open(downloadDocumentsUrl);
  };

  return (
    <SrText
      weight='medium'
      color='blue300'
      cursor='pointer'
      decoration={noUnderline ? null : 'underline'}
      className={className}
      onClick={onClickDownloadDocuments}
    >
      {children}
    </SrText>
  );
};

SrHouseholdDownloadDocuments.propTypes = {
  children: PropTypes.node.isRequired,
  householdId: PropTypes.number.isRequired,
  listingId: PropTypes.number.isRequired,
  appUrl: PropTypes.string.isRequired,
  noUnderline: PropTypes.bool,
  className: PropTypes.string,
  regenerateDocs: PropTypes.bool,
};

SrHouseholdDownloadDocuments.displayName = 'SrHouseholdDownloadDocuments';

export default SrHouseholdDownloadDocuments;
